import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { RxComponent } from '../../common/rx.component';
import { Observable } from 'rxjs';
import {SessionService} from '../../../services/session.service';
import {AuthService} from '../../../services/auth.service';

@Component({
  selector: 'itpx-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent extends RxComponent implements OnInit {

    private alerts: Observable<string[]>;
    private hiddenAlerts: any;
    private nrLogin: number;
    constructor(
        private router: Router,
        private alertService: AlertService,
        private sessionService: SessionService,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit() {
        this.alerts = this.alertService.alertsObserver;
        // this.readCookies();
    }

    close(alertId: string) {
        let userId = this.authService.isLoggedIn() ? this.sessionService.getUserDetails().id : null;
        this.alertService.hide(alertId, userId);
        this.readCookies();
    }

    private isAlertHidden(alertId: string) {
        this.readCookies();
        return this.hiddenAlerts && this.hiddenAlerts.length ? this.hiddenAlerts.includes(alertId) : false;
    }

    private readCookies() {
        if(this.authService.isLoggedIn()) {
            this.hiddenAlerts = this.alertService.readCookie('hide_alert_user_' + this.sessionService.getUserDetails().id);
            this.hiddenAlerts = this.hiddenAlerts ?  this.hiddenAlerts.split(',') : null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/partials/alert/alert.component.ts